<template>
<main id="mainWrapper">
    <div class="banner wrap">
        <router-link to="/register" tag="a" class="logo">
            立即体验
        </router-link>

    </div>
    <div class="customeManagement">
        <ul class="describe">
            <li>做淘宝如果只做淘宝，不做微信圈客户，你就是一条腿蹦着走，</li>
            <li>随时会摔倒，而且会一直很焦虑···</li>
            <li>如果你的客户没有存在你的微信里，那么他只是淘宝的客户，不是你的客户···</li>
            <li>一定要把客户存到微信做后端，这是卖家的终极稳定红利！</li>
            <li>谁做的早做得好，就会比竞争对手提前一两年建立起钢铁壁垒！</li>
            <li>单纯做淘宝就是在钓鱼，配合微信后端是：钓鱼+养鱼···</li>
        </ul>
    </div>

    <div class="solution01 wrap" id="solution01" name="#solution01">
        <div class="describe">
            <h3>终身客_全平台用户数据打通</h3>
            <ul>
                <li>支持多电商平台，多店铺客户数据打通</li>
                <li>支持电商购物订单管理，与客户轻松沟通</li>
                <li>智能标签分组+备注 精准触达用户</li>
                <li>从平台客户，转变自己粉丝，打造私域流量池</li>
            </ul>
        </div>
    </div>

    <div class="solution02 wrap" id="solution02" name="#solution02">
        <div class="describe">
            <h3>终身客_多微信号聚合管理</h3>
            <ul>
                <li>多微信号聚合聊天管理</li>
                <li>智能回复，快捷方便</li>
                <li>聊天记录同步保存，云存储</li>
                <li>智能红包发送，提高粉丝粘度</li>
            </ul>
        </div>
    </div>

    <div class="solution03 wrap" id="solution03" name="#solution04">
        <div class="describe">
            <h3>终身客_安全风控中心</h3>
            <ul>
                <li>客户聊天记录云存储</li>
                <li>监控各类敏感词</li>
                <li>如：员工辱骂客户、偷盗行为、客户不满等等</li>
                <li>聊天记录云监控，老板实时查看</li>
            </ul>
        </div>
    </div>

    <div class="solution05 wrap" id="solution05" name="#solution05">
        <div class="describe">
            <h3>终身客_朋友圈营销</h3>
            <ul>
                <li>查看、点赞、评论好友朋友圈</li>
                <li>聊天即时查看客户朋友圈，话题更易延伸</li>
                <li>编辑、预览、批量发布朋友圈</li>
                <li>精准针对标签客户，精确开发潜在需求，成交利器</li>
            </ul>
        </div>
    </div>

    <div class="solution04 wrap" id="solution04" name="#solution04">
        <div class="describe">
            <h3>终身客_智能数据分析管理</h3>
            <ul>
                <li>客户数据，全方位统计分析</li>
                <li>销售数据、回访记录精确到每位员工，轻松KPI考核</li>
                <li>跨平台数据管理，支持轻松客户追销、锁销、关联营销</li>
                <li>支持子账号、多部门架构，多手机设备管理</li>
            </ul>
        </div>
    </div>

    <div class="wrap solution04Content clearfix">
        <div class="item  slideInLeft animated"></div>
        <div class="item  slideInLeft animated"></div>
        <div class="item  slideInLeft animated"></div>
        <div class="item  slideInLeft animated"></div>
        <div class="item  slideInLeft animated"></div>
        <div class="item  slideInLeft animated"></div>
    </div>
    <div class="customerCase" id="customerCase" name="#customerCase">
        <div class="title"></div>
        <div class="wrap">
            <ul class="content clearfix">
                <li>
                    <img src="../../assets/Images/case1.jpg" alt="珠宝案例">
                    <p class="caseName">珠宝案例：珠宝类目TOP商家</p>
                    <b>使用后月均3000单</b>
                </li>
                <li>
                    <img src="../../assets/Images/case2.jpg" alt="女装案例">
                    <p class="caseName">女装案例：女装类目TOP商家</p>
                    <b>使用后月均250000单</b>
                </li>
                <li>
                    <img src="../../assets/Images/case3.jpg" alt="药膳案例">
                    <p class="caseName">药膳案例：药膳类目TOP商家</p>
                    <b>使用后月均50000单</b>
                </li>
                <li>
                    <img src="../../assets/Images/case4.jpg" alt="美妆案例">
                    <p class="caseName">美妆案例：美妆类目TOP商家</p>
                    <b>使用后月均150000单</b>
                </li>
                <li>
                    <img src="../../assets/Images/case5.jpg" alt="健身案例">
                    <p class="caseName">健身案例：健身类目TOP商家</p>
                    <b>使用后月均200000单</b>
                </li>
                <li>
                    <img src="../../assets/Images/case6.jpg" alt="茶叶案例">
                    <p class="caseName">茶叶案例：茶叶类目TOP商家</p>
                    <b>使用后月均90000单</b>
                </li>
            </ul>
        </div>
    </div>
</main>
</template>

<script>
import {
    WOW
} from 'wowjs'
export default {
    name: 'Home',
    mounted() {
        var options = {
            live:false
        };
        new WOW(options).init();
        let vm = this;
        this.$nextTick(() => {
            vm.goAnchor()
        })
    },
    methods: {
        goAnchor() {
            let anchor = sessionStorage.getItem("zhongshenkeanchor");
            if (anchor) {
                document.getElementById(anchor).scrollIntoView();
                // var targetPosition = document.getElementById(anchor).offsetTop;
                // document.querySelector("body").scrollTop = targetPosition - 90;
                sessionStorage.removeItem("zhongshenkeanchor")
            }
        }
    }

}
</script>

<style lang="scss" scoped>
#mainWrapper {
    &>div {
        background-position: center center;
        background-repeat: no-repeat;

        &.banner {
            height: 695px;
            position: relative;
            background-image: url('../../assets/Images/bannerIndex.jpg');

            a {
                background-color: #fff;
                color: #434343;
                padding: 8px 35px;
                border-radius: 5px;
                font-size: 28px;
                border: 1px solid #434343;
                position: absolute;
                top: 450px;
                left: 30px;
                cursor: pointer;
                outline: none;
            }

            a:hover {
                color: #000;
                border: 1px solid #333;
            }
        }

    }

    .customeManagement {
        height: 850px;
        background-color: #fafbfc;
        background-image: url('../../assets/Images/customeManagement.jpg');
    }
}

.solution01 {
    height: 722px;
    background-image: url('../../assets/Images/solution01.png');
}

.solution02 {
    height: 562px;
    background-image: url('../../assets/Images/solution02.png');
}

.solution03 {
    height: 572px;
    background-image: url('../../assets/Images/solution03.png');
}

.solution05 {
    height: 572px;
    background-image: url('../../assets/Images/solution05.png');
}

.solution04 {
    height: 287px;
    background-image: url('../../assets/Images/solution04.jpg');
}

.solution04Content {
    padding-left: 5px;
    margin-bottom: 30px;

    .item {
        float: left;
        width: 400px;
        margin: 0 15px 20px 0;
        height: 200px;
        -webkit-background-size: 100% 100%;
        background-size: 100% 100%;
        // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        box-shadow: 0 20px 20px -24px #9cd091;
        border: 1px solid #e7f5e9;
        transition: all .3s linear;
    }

    .item:hover {
        transform: translateY(-6px);
        -webkit-box-shadow: 0 20px 40px -24px #888;
        box-shadow: 0 20px 40px -24px #888;
        // -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }

    .item:nth-child(1) {
        background-image: url('../../assets/Images/solution04-1.png');
    }

    .item:nth-child(2) {
        background-image: url('../../assets/Images/solution04-2.png');
    }

    .item:nth-child(3) {
        background-image: url('../../assets/Images/solution04-3.png');
    }

    .item:nth-child(4) {
        background-image: url('../../assets/Images/solution04-4.png');
    }

    .item:nth-child(5) {
        background-image: url('../../assets/Images/solution04-5.png');
    }

    .item:nth-child(6) {
        background-image: url('../../assets/Images/solution04-6.png');
    }
}

.customerCase {
    background-color: #fafbfc;
    padding-bottom: 50px;

    .title {
        height: 135px;
        background: #fafbfc url('../../assets/Images/case.jpg') center center no-repeat;
    }

    .content {
        padding: 25px;

        li {
            background-color: #fff;
            float: left;
            margin: 0 15px 30px;
            color: #333;
            padding-bottom: 15px;
            transition: all .3s linear;

            &:hover {
                transform: translateY(-6px);
                -webkit-box-shadow: 0 20px 40px -24px #888;
                box-shadow: 0 20px 40px -24px #888;
            }

            &>img {
                width: 370px;
                height: 205px;
            }

            .caseName {
                font-size: 16px;
                padding-left: 20px;
                margin-top: 9px;
                line-height: 26px;
            }

            &>b {
                font-size: 17px;
                padding-left: 20px;
            }
        }
    }
}

.describe {
    display: none !important;
    opacity: 0 !important;
}
</style>
